import React from 'react';
import PropTypes from 'prop-types';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import { withStyles } from 'material-ui/styles/index';
import ContinueButton from '../../../common/components/Buttons/ContinueButton';
import colors from '../../../../config/themeColors';

const styles = ({ spacing: { unit } }) => ({
    root: {
        width: 'calc(100% - 32px)',
        textAlign: 'center',
        marginLeft: '16px',
        marginRight: '16px',
    },
    button: {
        marginLeft: unit * 2,
        '&:first-child': {
            marginLeft: 0,
        },
    },
    buttons: {
        marginTop: unit * 2,
        marginBottom: unit * 2,
        textAlign: 'center',
    },
    image: {
        width: '120px',
        height: '120px',
        borderRadius: '50%',
        backgroundColor: colors.white2,
        margin: '32px auto',
    },
    congratulation: {
        fontSize: '32px',
        lineHeight: 1.1,
    },
    congratulationDesc: {
        fontSize: '22px',
        lineHeight: 1.1,
    },
    congratulationDescSmaller: {
        fontSize: '14px',
        color: colors.brownishGrey,
        margin: '10px',
    },
});

function UnderWrittingCompleted(props) {
    return (
        <div className={props.classes.root}>
            <div className={props.classes.image}>
                &nbsp;
            </div>
            <Typography className={props.classes.congratulation}>
                Congratulation!
            </Typography>
            <Typography className={props.classes.congratulationDesc}>
                Your mortgage application is almost complete
            </Typography>
            <Typography className={props.classes.congratulationDescSmaller}>
                Please review and accept your offer in the Dashboard
            </Typography>
            <div className={props.classes.buttons}>
                <Button
                    className={props.classes.button}
                    variant="raised"
                    color="default"
                    onClick={() => {

                    }}
                >
                    Print your application
                </Button>
                <ContinueButton
                    className={props.classes.button}
                    onClick={() => {

                    }}
                >
                    Go to dashboard
                </ContinueButton>
            </div>
        </div>
    );
}

UnderWrittingCompleted.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(UnderWrittingCompleted);



// WEBPACK FOOTER //
// ./src/app/FormStepper/UnderwrittingSummary/components/UnderWrittingCompleted.js